module.exports = __webpack_public_path__ + "img/position-1.4425adfc.png";